import { mapState } from 'pinia';
import stores from 'store/modules';
import { CancelToken } from 'core/api';

export default {
    data: () => ({
        busy: false,
        contactIntegration: null,
        itemsIntegrationDuplicate: [],
        source: null,
        sourceConversation: null,
        searchType: 'search',
        newSearch: false,
    }),

    computed: {
        filterSections() {
            if (!this.hasIntegrations) return [];

            const sections = this.sectionContacts.filter((item) => {
                if (item.key === 'salesmsg') return true;
                if (!this.connectedIntegrations.includes(item.key)) return false;

                return true;
            });

            this.handleSectionClick(sections[0]);

            return sections;
        },

        total() {
            if (this.searchType === 'starter') {
                return this.starterTotalItemsCount;
            }

            return this.searchTotalItemsCount;
        },

        contactsExist() {
            if (this.searchType === 'starter') {
                return this.starterExistItemsCount;
            }

            return this.searchExistItemsCount;
        },

        canQuery() {
            if (this.newSearch) {
                return this.canSearchQueryHelp;
            }

            return this.canStartingQueryHelp;
        },

        isEmpty() {
            return !this.total;
        },

        activeDropDown() {
            return Boolean(this.active || !this.canQuery);
        },

        hasAllSearch() {
            return Boolean(this.showAllSearchItems);
        },

        loadingSearch() {
            if (this.searchType === 'starter') {
                return Boolean(this.contactsStarterAllLoading || this.busy);
            }

            return Boolean(this.contactsSearchAllLoading || this.busy);
        },

        ...mapState(stores.Inboxes, ['inbox']),
        ...mapState(stores.Search, [
            'contactsSearch',
            'contactsSearchPagination',
            'contactsStarter',
            'contactsStarterPagination',
            'contactsHubSpotSearch',
            'contactsHubSpotSearchPagination',
            'contactsHubSpotStarter',
            'contactsHubSpotStarterPagination',

            'contactsActiveCampaignSearch',
            'contactsActiveCampaignSearchPagination',
            'contactsActiveCampaignStarter',
            'contactsActiveCampaignStarterPagination',

            'contactsInfusionsoftSearch',
            'contactsInfusionsoftSearchPagination',
            'contactsInfusionsoftStarter',
            'contactsInfusionsoftStarterPagination',

            'contactsPipedriveSearch',
            'contactsPipedriveSearchPagination',
            'contactsPipedriveStarter',
            'contactsPipedriveStarterPagination',

            'contactsSalesforceSearch',
            'contactsSalesforceSearchPagination',
            'contactsSalesforceStarter',
            'contactsSalesforceStarterPagination',

            'conversationsSearch',
            'conversationsSearchPagination',

            'tagsSearch',
            'tagsSearchPagination',

            'inboxesSearch',
            'inboxesSearchPagination',

            'membersSearch',
            'membersSearchPagination',

            'segmentsSearch',
            'segmentsSearchPagination',

            'searchLimit',
            'sectionContacts',
            'sectionContactsSelected',
            'selectedTypeSearch',
            'selectedTypeItemsSearch',

            'querySearch',
            'querySearchHelpThree',
            'queryStarting',

            'contactsSearchAllLoading',
            'contactsStarterAllLoading',

            'canSearchQuery',
            'canSearchQuerySimple',
            'canStartingQuery',

            'canSearchQueryHelp',
            'canSearchQuerySimpleHelp',
            'canStartingQueryHelp',

            'searchTotalItemsCount',
            'starterTotalItemsCount',

            'searchExistItemsCount',
            'starterExistItemsCount',

            'hasGlobalSearch',
            'hasTypeSearch',
            'hasTypeItemsSearch',
            'showAllSearchItems',
            'querySearchThree',
        ]),
    },

    watch: {
        contactsSearchAllLoading(status) {
            if (!status) {
                this.busy = false;
                this.source = null;
                this.sourceConversation = null;
            }
        },
    },

    methods: {
        initForm(contactIntegration) {
            this.form.reset();
            this.form.number =
                contactIntegration.phone ||
                contactIntegration.mobile_phone ||
                contactIntegration.phones?.['Phone'] ||
                contactIntegration.phones?.['Mobile Phone'] ||
                '';
            this.form.first_name = contactIntegration.first_name || '';
            this.form.last_name = contactIntegration.last_name || '';
            this.form.email = contactIntegration.email || '';
            this.form.integration_id =
                this.getIntegrationUserPropsId(contactIntegration.typeContact) || '';
            this.form.contact_id = '';
            this.form.contact_integration_id = contactIntegration.id || '';
            this.form.phone_type = '';
        },

        totalSection(key) {
            if (this.searchType === 'starter') {
                switch (key) {
                    case 'hubspot':
                        return this.contactsHubSpotStarterPagination.total || 0;
                    case 'salesmsg':
                        return this.contactsStarterPagination.total || 0;
                    case 'activecampaign':
                        return this.contactsActiveCampaignStarterPagination.total || 0;
                    case 'infusionsoft':
                        return this.contactsInfusionsoftStarterPagination.total || 0;
                    case 'pipedrive':
                        return this.contactsPipedriveStarterPagination.total || 0;
                    case 'salesforce':
                        return this.contactsSalesforceStarterPagination.total || 0;
                    default:
                        return 0;
                }
            }

            switch (key) {
                case 'hubspot':
                    return this.contactsHubSpotSearchPagination.total || 0;
                case 'salesmsg':
                    return this.contactsSearchPagination.total || 0;
                case 'activecampaign':
                    return this.contactsActiveCampaignSearchPagination.total || 0;
                case 'infusionsoft':
                    return this.contactsInfusionsoftSearchPagination.total || 0;
                case 'pipedrive':
                    return this.contactsPipedriveSearchPagination.total || 0;
                case 'salesforce':
                    return this.contactsSalesforceSearchPagination.total || 0;
                default:
                    return 0;
            }
        },

        resetItems() {
            if (!this.total) return;

            this.$store.dispatch('searchResetContact', this.searchType);
            this.$store.dispatch('searchResetHubSpotContact', this.searchType);
            this.$store.dispatch('searchResetActiveCompaignContact', this.searchType);
            this.$store.dispatch('searchResetInfusionsoftContact', this.searchType);
            this.$store.dispatch('searchResetPipedriveContact', this.searchType);
            this.$store.dispatch('searchResetSalesforceContact', this.searchType);
            this.$store.dispatch('searchResetConversations', this.searchType);
            this.$store.dispatch('searchResetTags', this.searchType);
            this.$store.dispatch('searchResetInboxes', this.searchType);
            this.$store.dispatch('searchResetAssignedMembers', this.searchType);
        },

        resetLoading() {
            this.$store.dispatch('searchUpdateState', {
                searchContactsLoading: false,
                searchContactsHubSpotLoading: false,
                searchContactsActiveCampaignLoading: false,
                searchContactsInfusionsoftLoading: false,
                searchContactsPipedriveLoading: false,
                searchContactsSalesforceLoading: false,
                searchConversationsLoading: false,
                searchTagsLoading: false,
                searchInboxesLoading: false,
                searchMembersLoading: false,
            });
        },

        clearTotalContactsToBroadcast() {
            this.$emit('clearTotalContactsToBroadcast');
        },

        resetSourceAxios() {
            if (this.source) {
                this.source.cancel();
                this.source = null;
            }

            if (this.sourceConversation) {
                this.sourceConversation.cancel();
                this.sourceConversation = null;
            }
        },

        handleSectionClick(section) {
            this.$store.dispatch('searchUpdateState', {
                sectionContactsSelected: section,
            });
        },

        async searchContacts(query) {
            try {
                await this.$store.dispatch('searchContacts', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchContacts()`);
            }
        },

        async searchContactsBroadcast(query) {
            try {
                await this.$store.dispatch('searchContacts', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                    excludeOptOut: true,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchContacts()`);
            }
        },

        async searchActiveCampaignContacts(query) {
            if (!this.hasIntegrationUser('activecampaign')) return;

            try {
                await this.$store.dispatch('searchContactsActiveCampaign', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchActiveCampaignContacts()`);
            }
        },

        async searchHubSpotContacts(query) {
            if (!this.hasIntegrationUser('hubspot')) return;

            try {
                await this.$store.dispatch('searchContactsHubSpot', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchHubSpotContacts()`);
            }
        },

        async searchInfusionsoftContacts(query) {
            if (!this.hasIntegrationUser('infusionsoft')) return;

            try {
                await this.$store.dispatch('searchContactsInfusionsoft', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchInfusionsoftContacts()`);
            }
        },

        async searchPipedriveContacts(query) {
            if (!this.hasIntegrationUser('pipedrive')) return;

            try {
                await this.$store.dispatch('searchContactsPipedrive', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchPipedriveContacts()`);
            }
        },

        async searchSalesforceContacts(query) {
            if (!this.hasIntegrationUser('salesforce')) return;

            try {
                await this.$store.dispatch('searchContactsSalesforce', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                    searchType: this.searchType,
                    query: query,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchSalesforceContacts()`);
            }
        },

        async searchConversations() {
            try {
                await this.$store.dispatch('searchConversations', {
                    cancelToken: this.sourceConversation,
                    isSearchTop: this.newSearch,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchConversation()`);
            }
        },

        async searchTags() {
            try {
                await this.$store.dispatch('searchTags', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchTags()`);
            }
        },

        async searchSegments() {
            try {
                await this.$store.dispatch('searchSegments', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchSegments()`);
            }
        },

        async searchInboxes() {
            try {
                await this.$store.dispatch('searchInboxes', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchInboxes()`);
            }
        },

        async searchAssignedMembers() {
            try {
                await this.$store.dispatch('searchAssignedMembers', {
                    cancelToken: this.source,
                    isSearchTop: this.newSearch,
                });
            } catch (err) {
                console.log(`Error: ${err} - searchAssignedMembers()`);
            }
        },

        async searchEnter() {
            if (
                (this.hasGlobalSearch && this.canSearchQuery) ||
                (this.hasTypeItemsSearch && !this.hasTypeSearch)
            ) {
                this.busy = true;

                if (this.sourceConversation) {
                    this.sourceConversation.cancel();
                }

                this.sourceConversation = CancelToken.source();

                try {
                    await this.$store.dispatch('searchUpdateState', {
                        searchShowConversation: true,
                    });

                    await Promise.all([this.searchConversations()]);
                } catch (err) {
                    console.log(`Error: ${err} - searchEnter`);

                    this.resetItems();
                } finally {
                    this.busy = false;
                    this.active = false;
                    this.sourceConversation = null;
                }
            }
        },

        async searchConversationSimple() {
            this.busy = true;

            if (this.sourceConversation) {
                this.sourceConversation.cancel();
            }

            this.sourceConversation = CancelToken.source();

            try {
                await this.$store.dispatch('searchUpdateState', {
                    searchShowConversation: true,
                });

                await Promise.all([this.searchConversations()]);
            } catch (err) {
                console.log(`Error: ${err} - searchEnter`);

                this.resetItems();
            } finally {
                this.busy = false;
                this.sourceConversation = null;
            }
        },

        async search() {
            this.busy = true;
            this.active = true;

            this.resetSourceAxios();

            this.source = CancelToken.source();
            this.sourceConversation = CancelToken.source();

            try {
                if (this.newSearch) {
                    if (this.canSearchQuery) {
                        if (this.hasTypeSearch) {
                            if (this.selectedTypeSearch === 'tags') {
                                await Promise.all([this.searchTags()]);
                            }

                            if (this.selectedTypeSearch === 'contacts') {
                                await Promise.all([
                                    this.searchContacts(),
                                    this.searchHubSpotContacts(),
                                    this.searchActiveCampaignContacts(),
                                    this.searchInfusionsoftContacts(),
                                    this.searchPipedriveContacts(),
                                    this.searchSalesforceContacts(),
                                ]);
                            }

                            if (this.selectedTypeSearch === 'inboxes') {
                                await Promise.all([this.searchInboxes()]);
                            }

                            if (this.selectedTypeSearch === 'assigned_members') {
                                await Promise.all([this.searchAssignedMembers()]);
                            }

                            return;
                        }

                        if (this.querySearchThree) {
                            await Promise.all([
                                this.searchContacts(),
                                this.searchHubSpotContacts(),
                                this.searchActiveCampaignContacts(),
                                this.searchInfusionsoftContacts(),
                                this.searchPipedriveContacts(),
                                this.searchSalesforceContacts(),
                                this.searchTags(),
                                this.searchInboxes(),
                                this.searchAssignedMembers(),
                                this.searchConversations(),
                            ]);
                        } else {
                            await Promise.all([
                                this.searchTags(),
                                this.searchInboxes(),
                                this.searchAssignedMembers(),
                                this.searchConversations(),
                            ]);
                        }
                    }

                    return;
                }

                if (this.canStartingQuery) {
                    await Promise.all([
                        this.searchContacts(),
                        this.searchHubSpotContacts(),
                        this.searchActiveCampaignContacts(),
                        this.searchInfusionsoftContacts(),
                        this.searchPipedriveContacts(),
                        this.searchSalesforceContacts(),
                    ]);
                }
            } catch (err) {
                console.log(`Error: ${err} - search(start()`);

                this.resetItems();
            } finally {
                this.busy = false;
                this.source = null;
                this.sourceConversation = null;
            }
        },

        async createOrStartConversation(inbox_id, afterLInked = false) {
            try {
                this.form.forLink = afterLInked;

                this.form.number = this.form.number.replace(/[^0-9\s+\-()]/g, '');
                let newContact = await this.$store.dispatch('createContact', {
                    form: this.form,
                    updateCollection: false,
                });

                await this.handleStart(newContact, inbox_id);

                this.busy = false;
                this.starting = false;
            } catch (err) {
                const contactId = this.form.errors.get('contact_id');
                const number = this.form.errors.get('number');

                if (contactId) {
                    this.existingContactId = contactId;
                    this.form.contact_id = this.existingContactId;

                    let existContact = await this.$store.dispatch('contactLink', {
                        form: this.form,
                        id: this.existingContactId,
                        contactIntegration: this.contactIntegration,
                    });

                    await this.handleStart(existContact, inbox_id);
                } else {
                    this.$store.dispatch('showToast', {
                        type: 'danger',
                        message: number || `Phone [${this.form.number}] is invalid.`,
                    });
                }

                this.busy = false;
                this.starting = false;

                console.log(`Error: ${err} - createOrStartConversation()`);
            }
        },

        async createContactsIntegration(item, inbox_id) {
            this.busy = true;
            this.starting = true;

            let linked = {};

            try {
                const countPhone = item.phoneCount;
                const type = item.integration_type;
                let contactsDuplicate = [];

                // check duplicate
                if (!item.matchContact && item.phoneInfo) {
                    if (this.source) {
                        this.source.cancel();
                    }

                    this.source = CancelToken.source();
                    const data = {
                        query: item.phoneInfo,
                        limit: 50,
                        updateCollection: false,
                    };

                    if (type === 'hubspot') {
                        contactsDuplicate = await this.$store.dispatch(
                            'searchContactsHubSpot',
                            data
                        );
                    }

                    if (type === 'activecampaign') {
                        contactsDuplicate = await this.$store.dispatch(
                            'searchContactsActiveCampaign',
                            data
                        );
                    }

                    if (type === 'infusionsoft') {
                        contactsDuplicate = await this.$store.dispatch(
                            'searchContactsInfusionsoft',
                            data
                        );
                    }

                    if (type === 'pipedrive') {
                        contactsDuplicate = await this.$store.dispatch(
                            'searchContactsPipedrive',
                            data
                        );
                    }

                    if (type === 'salesforce') {
                        contactsDuplicate = await this.$store.dispatch(
                            'searchContactsSalesforce',
                            data
                        );
                    }

                    contactsDuplicate = contactsDuplicate.collection.modelsSortedHubSpot;

                    this.source = null;
                }

                // check linked
                try {
                    linked = await this.$store.dispatch('contactCheckLinked', {
                        contact: item,
                    });
                } catch (err) {}

                // open modal matching
                if (!item.matchContact && contactsDuplicate.length > 1) {
                    if (linked.result) {
                        this.$store.dispatch('showToast', {
                            type: 'danger',
                            message: 'Contact has been already linked',
                        });
                    } else {
                        this.itemsIntegrationDuplicate = contactsDuplicate;
                        this.openModalMatchingHandle();
                    }

                    this.busy = false;
                    this.starting = false;
                } else {
                    // open modal phones or create contact
                    if (linked.result) {
                        this.$store.dispatch('showToast', {
                            type: 'danger',
                            message: 'Contact has been already linked',
                        });

                        this.busy = false;
                        this.starting = false;
                    } else {
                        if (countPhone > 1) {
                            this.contact = item;
                            this.initForm(this.contact);
                            this.busy = false;
                            this.starting = false;
                            this.openModalCreateHandle();
                        } else {
                            this.contact = item;
                            this.initForm(this.contact);
                            await this.createOrStartConversation(inbox_id, true);
                        }
                    }
                }

                if (item.matchContact) {
                    this.closedModalMatchingHandle();
                }

                return {
                    linked: linked,
                };
            } catch (err) {
                console.log(`Error: ${err} - createContactsIntegration()`);

                this.busy = false;
                this.starting = false;

                if (item.matchContact) {
                    this.closedModalMatchingHandle();
                }
            }
        },

        changeProps({ name, value }) {
            this[name] = value;
        },

        openModalMatchingHandle() {
            this.openModalMatching = true;
        },

        openModalCreateHandle() {
            this.openModalCreate = true;
        },

        closedModalCreateHandle() {
            this.openModalCreate = false;
        },

        closedModalMatchingHandle() {
            this.openModalMatching = false;
        },

        setContact(item) {
            this.contact = item;
        },

        handleError(err) {
            for (let errors in err.response.data) {
                for (let error in err.response.data[errors]) {
                    this.$store.dispatch('showToast', {
                        type: 'danger',
                        message: err.response.data[errors][error],
                    });
                }
            }
        },
    },
};
